import { render, staticRenderFns } from "./CodeSnippet.vue?vue&type=template&id=02c2c3e4"
import script from "./CodeSnippet.vue?vue&type=script&lang=ts"
export * from "./CodeSnippet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports